export default __webpack_public_path__ + "static/media/page_not_found.a00aeec9.gif";